export const CrossIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
      fill="#C7222A"
    />
  </svg>
);
export const ErrorSymbol = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z"
      fill="#C7222A"
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg
    width={100}
    height={100}
    viewBox="0 0 1820 1820"
    class="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-1400 -420) scale(2.5)">
      <path
        d="M910.317037 172.562963C723.247407 172.562963 570.785185 325.025185 570.785185 512.094815c0 186.974815 152.462222 339.531852 339.531852 339.531852s339.721481-152.651852 339.721482-339.531852c0-187.06963-152.557037-339.531852-339.721482-339.531852z m0 632.225185c-161.185185 0-292.503704-131.697778-292.503704-292.693333 0-161.374815 131.318519-292.314074 292.503704-292.314074 161.28 0 292.693333 130.939259 292.693333 292.314074 0 160.995556-131.318519 292.693333-292.693333 292.693333z"
        fill="#5FFFBA"
      />
      <path
        d="M823.087407 497.682963c7.205926 13.463704 17.066667 29.771852 25.220741 45.700741 8.343704 16.213333 20.574815 38.684444 20.574815 38.684444s35.934815-74.714074 61.724444-113.493333c65.801481-98.702222 127.051852-122.121481 127.051852-122.121482s-6.352593 52.717037-5.688889 73.955556c0.758519 24.272593 10.808889 52.242963 10.808889 52.242963s-56.604444 32.900741-110.269629 90.832592c-33.848889 36.598519-79.36 108.468148-79.36 108.468149s-38.4-46.743704-68.645926-70.542223c-33.564444-26.453333-73.671111-47.881481-73.671111-47.881481s33.28-21.807407 50.157037-32.711111c16.971852-10.808889 42.097778-23.134815 42.097777-23.134815z"
        fill="#FFA28D"
      />
    </g>
  </svg>
);

export const Complete = () => {
  <svg width="48" height="47" viewBox="0 0 48 47" fill="none">
    <rect
      width="48"
      height="46"
      transform="translate(0 0.600098)"
      fill="url(#pattern0)"
    />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use transform="matrix(0.0282021 0 0 0.027027 -0.0217391 0)" />
      </pattern>
      <image id="image0_1443_3485" width="37" height="37" />
    </defs>
  </svg>;
};

export const LinkPPHI = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.167 5.83398H11.667C11.2087 5.83398 10.8337 6.20898 10.8337 6.66732C10.8337 7.12565 11.2087 7.50065 11.667 7.50065H14.167C15.542 7.50065 16.667 8.62565 16.667 10.0007C16.667 11.3757 15.542 12.5007 14.167 12.5007H11.667C11.2087 12.5007 10.8337 12.8757 10.8337 13.334C10.8337 13.7923 11.2087 14.1673 11.667 14.1673H14.167C16.467 14.1673 18.3337 12.3007 18.3337 10.0007C18.3337 7.70065 16.467 5.83398 14.167 5.83398ZM6.66699 10.0007C6.66699 10.459 7.04199 10.834 7.50033 10.834H12.5003C12.9587 10.834 13.3337 10.459 13.3337 10.0007C13.3337 9.54232 12.9587 9.16732 12.5003 9.16732H7.50033C7.04199 9.16732 6.66699 9.54232 6.66699 10.0007ZM8.33366 12.5007H5.83366C4.45866 12.5007 3.33366 11.3757 3.33366 10.0007C3.33366 8.62565 4.45866 7.50065 5.83366 7.50065H8.33366C8.79199 7.50065 9.16699 7.12565 9.16699 6.66732C9.16699 6.20898 8.79199 5.83398 8.33366 5.83398H5.83366C3.53366 5.83398 1.66699 7.70065 1.66699 10.0007C1.66699 12.3007 3.53366 14.1673 5.83366 14.1673H8.33366C8.79199 14.1673 9.16699 13.7923 9.16699 13.334C9.16699 12.8757 8.79199 12.5007 8.33366 12.5007Z"
      fill="#B37671"
    />
  </svg>
);

export const CopyPPhi = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.917 16.666H4.58366V5.83268C4.58366 5.37435 4.20866 4.99935 3.75033 4.99935C3.29199 4.99935 2.91699 5.37435 2.91699 5.83268V16.666C2.91699 17.5827 3.66699 18.3327 4.58366 18.3327H12.917C13.3753 18.3327 13.7503 17.9577 13.7503 17.4993C13.7503 17.041 13.3753 16.666 12.917 16.666ZM17.0837 13.3327V3.33268C17.0837 2.41602 16.3337 1.66602 15.417 1.66602H7.91699C7.00033 1.66602 6.25033 2.41602 6.25033 3.33268V13.3327C6.25033 14.2493 7.00033 14.9993 7.91699 14.9993H15.417C16.3337 14.9993 17.0837 14.2493 17.0837 13.3327ZM15.417 13.3327H7.91699V3.33268H15.417V13.3327Z"
      fill="#B37671"
    />
  </svg>
);

export const RedoPPhi = () => (
  <svg
    stroke="currentColor"
    fill="#b37671"
    stroke-width="0"
    viewBox="0 0 20 24"
    height="20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path>
  </svg>
);

export const PPHIOrderSuccess = () => (
  <svg
    width="111"
    height="110"
    viewBox="0 0 111 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5.5" y="5" width="100" height="100" rx="50" fill="#D1FADF" />
    <rect
      x="5.5"
      y="5"
      width="100"
      height="100"
      rx="50"
      stroke="#ECFDF3"
      stroke-width="10"
    />
    <path
      d="M82.0837 53.0076V55.4992C82.0803 61.3395 80.1892 67.0223 76.6923 71.7C73.1954 76.3777 68.2801 79.7997 62.6794 81.4556C57.0788 83.1116 51.0929 82.9127 45.6145 80.8887C40.1361 78.8647 35.4588 75.1241 32.28 70.2246C29.1013 65.3252 27.5914 59.5294 27.9757 53.7017C28.36 47.8741 30.6178 42.3268 34.4123 37.8871C38.2069 33.4475 43.335 30.3534 49.0317 29.0663C54.7284 27.7792 60.6886 28.3681 66.0233 30.7451M82.0837 33.8326L55.0003 60.943L46.8753 52.818"
      stroke="#039855"
      stroke-width="4.33"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PPHIOrderFailed = () => (
  <svg
    width="111"
    height="110"
    viewBox="0 0 111 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5.5" y="5" width="100" height="100" rx="50" fill="#FEE4E2" />
    <rect
      x="5.5"
      y="5"
      width="100"
      height="100"
      rx="50"
      stroke="#FEF3F2"
      stroke-width="10"
    />
    <path
      d="M55.0003 44.666V55.4993M55.0003 66.3327H55.0274M82.0837 55.4993C82.0837 70.4571 69.958 82.5827 55.0003 82.5827C40.0426 82.5827 27.917 70.4571 27.917 55.4993C27.917 40.5416 40.0426 28.416 55.0003 28.416C69.958 28.416 82.0837 40.5416 82.0837 55.4993Z"
      stroke="#D92D20"
      stroke-width="5.33"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PPHIOrderInProgress = () => (
  <svg
    width="111"
    height="110"
    viewBox="0 0 111 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5.5" y="5" width="100" height="100" rx="50" fill="#FEF3C7" />
    <rect
      x="5.5"
      y="5"
      width="100"
      height="100"
      rx="50"
      stroke="#FEF9C3"
      stroke-width="10"
    />
    <path
      d="M55.0003 44.666V55.4993M55.0003 66.3327H55.0274M82.0837 55.4993C82.0837 70.4571 69.958 82.5827 55.0003 82.5827C40.0426 82.5827 27.917 70.4571 27.917 55.4993C27.917 40.5416 40.0426 28.416 55.0003 28.416C69.958 28.416 82.0837 40.5416 82.0837 55.4993Z"
      stroke="#A16207"
      stroke-width="5.33"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PPHIcheckBOX = () => (
  <svg
    stroke="green"
    fill="green"
    strokeWidth="0"
    version="1.1"
    viewBox="0 0 16 16"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 2.293 2.293 4.793-4.793 1.414 1.414-6.207 6.207z" />
  </svg>
);

export const PPHIMessageBox = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 24 24"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.45455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.45455ZM5.76282 17H20V5H4V18.3851L5.76282 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"></path>
  </svg>
);
